import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import { User, Mail, Phone, MapPin } from "lucide-react";

export const ContactInfoStep = ({ formData, onInputChange }) => (
  <div data-testid="quote-step-3" className="space-y-6">
    <div>
      <h2 className="font-heading text-2xl font-bold uppercase text-brand-navy mb-2">
        Contact Information
      </h2>
      <p className="text-brand-slate">
        How can we reach you about your project?
      </p>
    </div>

    <div className="grid md:grid-cols-2 gap-4">
      <div className="md:col-span-2">
        <Label htmlFor="full_name" className="text-brand-navy">Full Name *</Label>
        <div className="relative mt-2">
          <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-brand-slate" />
          <Input
            id="full_name"
            data-testid="full-name"
            placeholder="John Smith"
            value={formData.full_name}
            onChange={(e) => onInputChange("full_name", e.target.value)}
            className="pl-10 border-border focus:border-brand-orange"
          />
        </div>
      </div>

      <div>
        <Label htmlFor="email" className="text-brand-navy">Email Address *</Label>
        <div className="relative mt-2">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-brand-slate" />
          <Input
            id="email"
            type="email"
            data-testid="email"
            placeholder="john@example.com"
            value={formData.email}
            onChange={(e) => onInputChange("email", e.target.value)}
            className="pl-10 border-border focus:border-brand-orange"
          />
        </div>
      </div>

      <div>
        <Label htmlFor="phone" className="text-brand-navy">Phone Number *</Label>
        <div className="relative mt-2">
          <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-brand-slate" />
          <Input
            id="phone"
            type="tel"
            data-testid="phone"
            placeholder="+00000-00000"
            value={formData.phone}
            onChange={(e) => onInputChange("phone", e.target.value)}
            className="pl-10 border-border focus:border-brand-orange"
          />
        </div>
      </div>

      <div className="md:col-span-2">
        <Label htmlFor="address" className="text-brand-navy">Project Address</Label>
        <div className="relative mt-2">
          <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-brand-slate" />
          <Input
            id="address"
            data-testid="address"
            placeholder="123 Main Street"
            value={formData.address}
            onChange={(e) => onInputChange("address", e.target.value)}
            className="pl-10 border-border focus:border-brand-orange"
          />
        </div>
      </div>

      <div>
        <Label htmlFor="city" className="text-brand-navy">City</Label>
        <Input
          id="city"
          data-testid="city"
          placeholder="Your City"
          value={formData.city}
          onChange={(e) => onInputChange("city", e.target.value)}
          className="mt-2 border-border focus:border-brand-orange"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="state" className="text-brand-navy">State</Label>
          <Input
            id="state"
            data-testid="state"
            placeholder="TX"
            value={formData.state}
            onChange={(e) => onInputChange("state", e.target.value)}
            className="mt-2 border-border focus:border-brand-orange"
          />
        </div>
        <div>
          <Label htmlFor="zip_code" className="text-brand-navy">ZIP Code</Label>
          <Input
            id="zip_code"
            data-testid="zip-code"
            placeholder="00000"
            value={formData.zip_code}
            onChange={(e) => onInputChange("zip_code", e.target.value)}
            className="mt-2 border-border focus:border-brand-orange"
          />
        </div>
      </div>

      <div className="md:col-span-2">
        <Label className="text-brand-navy">Preferred Contact Method</Label>
        <RadioGroup
          value={formData.preferred_contact}
          onValueChange={(value) => onInputChange("preferred_contact", value)}
          className="flex gap-6 mt-3"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="email" id="contact-email" data-testid="contact-email" />
            <Label htmlFor="contact-email" className="cursor-pointer">Email</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="phone" id="contact-phone" data-testid="contact-phone" />
            <Label htmlFor="contact-phone" className="cursor-pointer">Phone</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="whatsapp" id="contact-whatsapp" data-testid="contact-whatsapp" />
            <Label htmlFor="contact-whatsapp" className="cursor-pointer">WhatsApp</Label>
          </div>
        </RadioGroup>
      </div>
    </div>
  </div>
);
